import React, { Component } from "react"
import { ModalContainer, ModalDialog, HttpError } from "react-modal-dialog"
import ContratadosForm from "./ContratadosForm"
import * as ApiHelper from "../../ApiHelper"
export default class ContratadosModal extends Component {
  constructor() {
    super()
    this.callBackContratados = this.callBackContratados.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getContratados((contratados, error) => {
      if (contratados) {
        this.props.callBack(contratados)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackContratados() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <ContratadosForm callBackContratados={this.callBackContratados} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/ContratadosModal.js